import React from "react";
import { DateTime } from "luxon";
import { shootTime } from "./MySchedule";
import "./MobileAgenda.css";

export function groupAgendaAppointments(appointments, start, end) {
  const groups = new Map();
  appointments.forEach(appointment => {
    const day = DateTime.fromISO(appointment.appointmentDate || "").setZone("America/New_York");
    if (!day.isValid || day.toISODate() < start.toISODate() || day.toISODate() > end.toISODate()) return;
    const key = day.toISODate();
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(appointment);
  });
  return [...groups.entries()].sort(([a], [b]) => a.localeCompare(b)).map(([day, shoots]) => [day,
    shoots.sort((a,b) => (shootTime(a.startTime, day)?.toMillis() || DateTime.fromISO(a.appointmentDate).toMillis()) -
      (shootTime(b.startTime, day)?.toMillis() || DateTime.fromISO(b.appointmentDate).toMillis()))]);
}

export default function MobileAgenda({ appointments, start, end, onOpen, onPrevious, onNext, onToday }) {
  const groups = groupAgendaAppointments(appointments, start, end);
  const today = DateTime.now().setZone("America/New_York").toISODate();
  return <section className="mobile-agenda" aria-label="Agenda">
    <div className="mobile-agenda-navigation"><button aria-label="Previous date range" onClick={onPrevious}>Previous</button><button onClick={onToday}>Today</button><button aria-label="Next date range" onClick={onNext}>Next</button></div>
    <p className="mobile-agenda-range">{start.toFormat("MMM d, yyyy")} – {end.toFormat("MMM d, yyyy")}</p>
    <p className="mobile-agenda-help">Your calendar filters apply here too. Tap a shoot for details.</p>
    {!groups.length && <p className="mobile-agenda-empty" role="status">No appointments in this date range match your filters.</p>}
    {groups.map(([day, shoots]) => <section className="mobile-agenda-day" key={day}>
      <h2>{day === today ? "Today · " : ""}{DateTime.fromISO(day).toFormat("cccc, MMM d")}</h2>
      {shoots.map(shoot => {
        const time = shootTime(shoot.startTime, day) || DateTime.fromISO(shoot.appointmentDate).setZone("America/New_York");
        const finish = shootTime(shoot.endTime || shoot.endDate, day);
        const canceled = ["black", "#000000", "000000"].includes(String(shoot.color || "").toLowerCase());
        return <button className="mobile-agenda-card" key={shoot.id} onClick={() => onOpen(shoot)}>
          <span className="mobile-agenda-time">{time.toFormat("h:mm a")}{finish ? ` – ${finish.toFormat("h:mm a")}` : ""}</span>
          <strong>{shoot.client || "Appointment"}</strong>
          {canceled && <span className="mobile-agenda-canceled">Canceled</span>}
          <span>{Array.isArray(shoot.photographers) ? shoot.photographers.join(", ") : shoot.photographers || "No photographers assigned"}</span>
          {shoot.fieldBuildingLocation && <span>{shoot.fieldBuildingLocation}</span>}
          {shoot.address && <span>{shoot.address}</span>}
          <span className="mobile-agenda-open">View details →</span>
        </button>;
      })}
    </section>)}
  </section>;
}
